import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './OccurrenceForm.html?raw';
import "./OccurrenceFMtype";

type OccurrenceFMTaskList__mdsbase = InstanceType<typeof _WidgetBaseSP>;
interface OccurrenceFMTaskList extends OccurrenceFMTaskList__mdsbase { }
class OccurrenceFMTaskList {
    templateString;

    occurrenceID: string;
    _executions;
    _files;
    _showExecutions;


    _statusChangeDlg;

    isExternalEmployee: boolean;

    _flatratesData;
    _assistantData;

//        postMixInProperties: function () {
//            this.inherited(arguments);
//        }
//        postCreate: function () {
//            this.inherited(arguments);
//            this.RequestManager.silentExceptions = true;
//            this._showExecutions = [];
//        }

//        startup: function () {
//            this.inherited(arguments);
//        }

//        loadScheduledTaskExecutors: function () {
//            domClass.add(this.sectionEmployeeTasks, "w3-hide");

//            this._executions = [];
//            this._files = [];

//            this.StandbyStart();

//            var url = window.appRoot + "Occurrence/GetMyTasksJSON";

//            if (this.occurrenceID == null || typeof (this.occurrenceID) == "undefined") {
//                return
//            }

//            domClass.remove(this.sectionEmployeeTasks, "w3-hide");

//            this.RequestManager.post(
//                url,
//                {
//                    occurrenceID: this.occurrenceID
//                }
//                lang.hitch(this, "_onLoadScheduledTaskExecutorsResponse"),
//                lang.hitch(this, "_onLoadScheduledTaskExecutorsError"),
//                false // sync
//            );
//        }

//        _onLoadScheduledTaskExecutorsResponse: function (taskList) {
//            this.StandbyStop();

//            console.log("taskresponse", taskList);
//            if (taskList.length > 0) {
//                domClass.remove(this.employeeTasksContainer, "w3-hide");
//            } else {
//                domClass.remove(this.employeeTasksContainer, "w3-hide");
//                domConstruct.empty(this.employeeTasksContainer);
//                domConstruct.create("div", {
//                    style: {
//                        "fontStyle": "italic"
//                    },
//                    className: "w3-text-gray",
//                    "innerHTML": this.translations["_general__noEntries"]//"keine Einträge"
//                }, this.employeeTasksContainer)
//                return;
//            }

//            // employeeTasksContainer
//            this.employeeTasksTable = new Tabulator(this.employeeTasksContainer, {
//                data: taskList,
//                selectableCheck: lang.hitch(this, "tableSelectableCheck"),
//                layout: "fitColumns",
//                index: "ID", // WIESO GEHT DES NED?!
//                //height: "311px",
//                columns: [
//                    {
//                        title: this.translations["OccurrenceTaskList__TableCol_Number"]/*"Nummer"*/, field: "Number", width: 100, editor: false
//                    },
//                    {
//                        title: this.translations["OccurrenceTaskList__TableCol_Status"]/*"Status"*/, field: "ref_status.Name", width: 150, editor: false, formatter: lang.hitch(this, "tableFormatterStatus")
//                    },
//                    {
//                        title: this.translations["OccurrenceTaskList__TableCol_Actions"]/*"Aktionen"*/, field: "ID", formatter: lang.hitch(this, "tableBtnActions"), headerSort: false
//                    },

//                ],
//                rowFormatter: lang.hitch(this, "_appendNestedTable"),
//            });

//            domStyle.set(this.employeeTasksContainer, "fontSize", "12px");

//            //console.log("executions to show", this._showExecutions);
//            for (var i = 0; i < this._showExecutions.length; i++) {
//                this._onClick__ExpandTaskExecutor(this._showExecutions[i]);
//            }
//        }

//        tableSelectableCheck: function (row) {
//            return false;
//        }

//        _appendNestedTable: function (row) {
//            var data = row.getData();
//            var container = domConstruct.create("div", { className: "w3-padding w3-border-left w3-border-right w3-border-blue w3-pale-blue" });
//            var heading = domConstruct.create("div", { "innerHTML": this.translations["OccurrenceTaskExecutions__Heading"]/*"Ausführungen"*/, className: "w3-medium" }, container);
//            var tableDiv = domConstruct.create("div");

//            domClass.add(tableDiv, "");
//            domClass.add(heading, "");

//            domConstruct.place(container, row.getElement());
//            domConstruct.place(heading, container);
//            domConstruct.place(tableDiv, container);


//            var subTable = new Tabulator(tableDiv, {
//                data: data.TaskExecutors,
//                layout: "fitColumns",
//                selectableCheck: lang.hitch(this, "tableSelectableCheck"),
//                //height: "111px",
//                columns: [
//                    { title: this.translations["OccurrenceTaskExecutions__TableCol_Employee"]/*"Mitarbeiter"*/, field: "ref_employee.DispName", editor: false, formatter: lang.hitch(this, "tableFormatterEmployee") },
//                    { title: this.translations["OccurrenceTaskExecutions__TableCol_Status"]/*"Status"*/, field: "ref_scheduled_task_executer_status.Name", editor: false, formatter: lang.hitch(this, "tableFormatterStatus") },
//                    { title: this.translations["OccurrenceTaskExecutions__TableCol_History"]/*"Status"*/, field: "tmp_history_info", editor: false, width: 400 },
//                ]
//            });

//            domStyle.set(tableDiv, "fontSize", "12px");

//            subTable.getRows().forEach(function (row) {
//                row.normalizeHeight();
//            });

//            this._executions.push({ node: container, ID: data.ID });
            
//            domClass.add(container, "w3-hide");

//            // FILES!
//            let buttonStates = JSON.parse(data.tmp_buttonstates);
//            let fileContainer = domConstruct.create("div", { className: "w3-padding w3-border-right w3-border-left w3-border-orange w3-pale-yellow w3-hide" }, row.getElement());

//            this._files.push({ node: fileContainer, ID: data.ID });
//            if (data.Files && buttonStates._showFiles === true) {
//                if (data.Files.length > 0) {
                    

//                    let heading = domConstruct.create("div",
//                        {
//                            "innerHTML": this.translations["OccurrenceTaskExecutions__FilesHeading"],
//                            className: "w3-medium w3-border-top w3-padding-y"
//                        },
//                        fileContainer);

//                    let filesTable = domConstruct.create("div", { className: "flex_row" }, heading);


//                    for (let i = 0; i < data.Files.length; i++) {
//                        let file = data.Files[i];

//                        let fileRowDiv = domConstruct.create("div",
//                            {
//                                className: "flex_row_center w3-margin-right w3-light-gray ",
//                                //innerHTML: file.Filename
//                            },
//                            filesTable);

//                        domConstruct.create("span",
//                            {
//                                className: "w3-padding-small",
//                                innerHTML: file.Filename
//                            }, fileRowDiv)


//                        if (file._canDownload === true) {
//                            let downloadButton = domConstruct.create("div",
//                                {
//                                    className: "w3-padding-small",
//                                    innerHTML: "<i class='fa fa-download'></i>"
//                                },
//                                fileRowDiv
//                            );

//                            domClass.add(fileRowDiv, "mds-hover-dark");

//                            on(fileRowDiv, "click", lang.hitch(this, this._onClickDownloadFile, file.ID))
//                        }

//                        if (file._canRemove) {
//                            let removeBtn = domConstruct.create("div",
//                                {
//                                    className: "w3-padding-small w3-pale-red mds-hover-dark",
//                                    innerHTML: "<i class='fa fa-times w3-text-red'></i>"
//                                },
//                                fileRowDiv
//                            );

//                            on(removeBtn, "click", lang.hitch(this, this._onClick_RemoveFile, file.ID, data.ID, filesTable));
//                        };
//                    }
//                }
//            }

//            if (buttonStates._uploadFiles === true) {
//                let uploadContainer = domConstruct.create("div", {
//                    className: "w3-medium w3-margin-top w3-padding-y w3-border-top",
//                    innerHTML: this.translations["OccurrenceTaskExecutions__FilesUploadHeading"]
//                }, fileContainer);
                    
//                //let fileupload = domConstruct.create("input",
//                //    {
//                //        "className": "w3-block w3-padding-y",
//                //        "type": "file",
//                //        "multiple": "true"
//                //        //"disabled": this.isReadonly === true ? "disabled" : "false",
//                //    }, uploadContainer);


//                let fileupload = new SimpleFileUpload();
//                fileupload.set("MultipleMode", true);
//                fileupload.set("submitCallback", lang.hitch(this, this._onUploadTaskfileResponse, row));
//                fileupload.set("UploadUrl", "Occurrence/UploadTaskFile"); // egal, weil wir eh nicht 
//                fileupload.set("maxSize", 9);
//                domConstruct.place(fileupload.domNode, fileContainer);

//                let buttonContainer = domConstruct.create("div", {} fileContainer);

//                on(fileupload, "change", lang.hitch(this, this._onChange_Fileinput, buttonContainer, fileupload, data));


//                fileupload.startup();


//            }
            
//        }

//        _onChange_Fileinput: function (domnode, fileupload, data) {
//            let uploadData = fileupload.getUploadData();
//            console.log("_onChange_Fileinput", domnode, uploadData, data);

//            domConstruct.empty(domnode);
//            if (uploadData) {
//                let button = domConstruct.create("button", {
//                    className: "w3-button accentcolor w3-padding-small mds-hover-bright",
//                    innerHTML: "Upload&nbsp;<i class='fa fa-upload'></i>"
//                } domnode);

//                on(button, "click", lang.hitch(fileupload, "_StartUpload", { taskID: data.ID } ));
//            }
//        }

//        _onUploadTaskfileResponse(row, response) {
//            console.debug("_onUploadTaskfileResponse", row, [response]);

//            //let result = this.employeeTasksTable.updateData([response]);

//            //if (result != true) {
//            //    alert("upate failed");
//            //}

//            //let result = this.employeeTasksTable.setData([response]);

//            //if (result != true) {
//            //    alert("upate failed");
//            //}

//            this.loadScheduledTaskExecutors(); // nix von da oben geht, Tabulator is einfach gschissn. Forever.

//        }

//        _onClick_RemoveFile: function (fileID, taskID, domnode, evt) {
//            evt.stopPropagation();

//            this.StandbyStart(domnode);

//            var url = window.appRoot + "Occurrence/RemoveTaskFile";

//            let data = { "fileID": fileID, "taskID": taskID };

//            this.RequestManager.post(
//                url,
//                {
//                    jsonData: JSON.stringify(data)
//                },
//                lang.hitch(this, this._onRemoveTaskFileResponse),
//                lang.hitch(this, this._onRemoveTaskFileError),
//                false // sync
//            );
//        }
//        _onRemoveTaskFileError: function (error) {
//            console.error(error.Message);
//            this.StandbyStop();
//        }


//        _onRemoveTaskFileResponse(response) {
//            this.StandbyStop();

//            this.loadScheduledTaskExecutors(); // nix von da oben geht, Tabulator is einfach gschissn. Forever.
//        }

//        _onClickDownloadFile: function (fileID, evt) {
//            evt.stopPropagation();
//            console.debug("_onClickDownloadFile", fileID, evt);

//            var url = window.appRoot + "Occurrence/DownloadTaskFile?ID=" + fileID;
//            window.open(url);
//        }

//        //custom formatter definition
//        tableBtnActions: function (cell, formatterParams, onRendered) { //plain text value

//            var data = cell.getRow().getData();
//            var buttonStates = JSON.parse(data.tmp_buttonstates);

//            var container = domConstruct.create("div");
//            domClass.add(container, "flex_row");
//            //console.log("tableBtnActions", data, buttonStates);

//            if (buttonStates.button_accept === true) {
//                var button = domConstruct.create("div");
//                domClass.add(button, "w3-padding-small mds-bg-gray mds-hover-dark zal-table-action-button");
//                domAttr.set(button, "innerHTML", "<i class='fa fa-bolt'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Accept"] /*annehmen"*/);
//                domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_AcceptTooltip"]);
//                domConstruct.place(button, container);
//                on(button, "click", lang.hitch(this, "_onClick__AcceptTask", data));
//            }

//            if (buttonStates.button_complete === true) {
//                var button = domConstruct.create("div");
//                domClass.add(button, "w3-padding-small mds-bg-gray mds-hover-dark zal-table-action-button");
//                domAttr.set(button, "innerHTML", "<i class='fa fa-check'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Finish"] /*erledigen"*/);
//                domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_FinishTooltip"]);
//                domConstruct.place(button, container);
//                on(button, "click", lang.hitch(this, "_onClick__CompleteTask", data));
//            }

//            if (buttonStates.button_pause === true) {
//                var button = domConstruct.create("div");
//                domClass.add(button, "w3-padding-small mds-bg-gray mds-hover-dark zal-table-action-button");
//                domAttr.set(button, "innerHTML", "<i class='fa fa-pause'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Pause"] /*unterbrechen"*/);
//                domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_PauseTooltip"]);
//                domConstruct.place(button, container);
//                on(button, "click", lang.hitch(this, "_onClick__PauseTask", data));
//            }

//            if (buttonStates.button_start === true) {
//                var button = domConstruct.create("div");
//                domClass.add(button, "w3-padding-small mds-bg-gray mds-hover-dark zal-table-action-button");
//                domAttr.set(button, "innerHTML", "<i class='fa fa-play'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Start"] /*Bearbeitung starten"*/);
//                domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_StartTooltip"]);
//                domConstruct.place(button, container);
//                on(button, "click", lang.hitch(this, "_onClick__StartTask", data));
//            }

//            // Button zum Aufklappen der Ausführungen
//            if (data.TaskExecutors.length > 0) {
//                var button = domConstruct.create("div");
//                domClass.add(button, "w3-padding-small w3-center mds-bg-gray mds-hover-dark zal-table-action-button");
//                domAttr.set(button, "innerHTML", "<i class='fa fa-caret-down'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_ShowEx"]);
//                domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_ShowExTooltip"]);
//                domConstruct.place(button, container);
//                on(button, "click", lang.hitch(this, "_onClick__ExpandTaskExecutor", data.ID, button));
//            }

//            return container;

//        }

//        _onClick__ExpandTaskExecutor: function (ID, button) {
//            //console.log("_onClick__ExpandTaskExecutor", ID, this._executions);
//            for (var i = 0; i < this._executions.length; i++) {
//                var execution = this._executions[i];
//                let file = this._files[i];

//                if (execution.ID == ID && execution.node != null) {
//                    if (domClass.contains(execution.node, "w3-hide")) {
//                        domClass.remove(execution.node, "w3-hide");
//                        domClass.remove(file.node, "w3-hide");

//                        // merken welche Aufträge ausgeklappt waren:
//                        if (this._showExecutions.indexOf(ID) == -1) {
//                            this._showExecutions.push(ID);
//                        }

//                        if (typeof (button) != "undefined") {
//                            domAttr.set(button, "innerHTML", "<i class='fa fa-caret-up'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_HideEx"]);
//                            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_HideExTooltip"])
//                        }
//                    } else {
//                        domClass.add(execution.node, "w3-hide");
//                        domClass.add(file.node, "w3-hide");
//                        this._showExecutions.splice(this._showExecutions.indexOf(ID), 1);
//                        if (typeof (button) != "undefined") {
//                            domAttr.set(button, "innerHTML", "<i class='fa fa-caret-down'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_ShowEx"]);
//                            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_ShowExTooltip"]);
//                        }
//                    }
//                    break;
//                }
//            }
//        }

//        showStatusChangeDialog: function (taskEntity, header, subtitle, callback) {
//            var dialog = new GenericDialog;
//            this._statusChangeDlg = dialog;
//            dialog.destroyOnClose = false;
//            domStyle.set(dialog.textNode, "height", "unset");
//            domStyle.set(dialog.textNode, "maxHeight", "unset");
//            dialog.hideSubtitleNode(true);
//            dialog.set("ok", true);
//            dialog.set("cancel", true);
//            //dialog.set("content", "Hier Freitexteingabe");
//            domAttr.set(this.subtitleText, "innerHTML", subtitle); // eigener Subtitle-Knoten im inputdiv, der dann zum Content kommt!
//            dialog.set("header", header);//taskEntity.Number + " erledigen");


//            var inputDiv = this.inputDiv;//domConstruct.create("div");
//            domClass.remove(inputDiv, "w3-hide");

//            if (this.isExternalEmployee != true) {
//                domClass.remove(this.accountingContainer, "w3-hide");
//                this.inputAssistantEmployee._loadListValues();
//            } else {
//                domClass.add(this.accountingContainer, "w3-hide");
//            }

//            this.inputWorkingAmount.value = 1;

//            var input = this.taskInput; //domConstruct.create("textarea", {}, inputDiv);
//            input.value = "";
//            //domClass.add(input, "w3-input w3-block");
//            dialog.addNodeToContent(inputDiv);
//            //domAttr.set(input, "placeholder", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]);//"Anmerkungen?");
//            //domAttr.set(input, "placeholder", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]);//"Anmerkungen?");

//            //domAttr.set(input, "value", this.comment); // es sollte ein Standardtext irgendwoher kommen...

//            // verhinden dass mit "Enter" der Dialog beendet wird
//            on(input, "keyup", function (evt) {
//                evt.stopPropagation();
//            });

//            domConstruct.empty(this.selectedAssistantContainer);

//            if (this._flatratesSelect != null) {
//                //this._flatratesSelect.destroy();
//                domConstruct.empty(this.taskFlatratesContainer);
//                this._flatratesSelect = null;

//                domConstruct.empty(this.taskFlatratesTableContainer);
//            }

//            // multiselect für die pauschalen
//            this._flatratesSelect = new MultiSelect();
//            domConstruct.place(this._flatratesSelect.domNode, this.taskFlatratesContainer);//inputDiv);
//            this._flatratesSelect.set("labelAttribute", 'bezeichnung');
//            this._flatratesSelect.set("valueAttribute", 'ID');

//            on(this._flatratesSelect, "change", lang.hitch(this, this._onChangeSelectedFlatrates));

//            if (this.isExternalEmployee != true) {
//                this._loadFlatrates(taskEntity);
//                domClass.remove(this.assistantContainer, "w3-hide");
//            } else {
//                domClass.add(this.assistantContainer, "w3-hide");
//            }

//            this._assistantData = [];

//            dialog.set("callback", callback);

//            dialog.show();

//            //console.log("cell mehrfachauswahl", cell, cellData, options);

//            input.style.width = "100%";
//        }

        

//        _onClick__PauseTask: function (taskEntity) {
//            let header = this.translations["OccurrenceTaskExecutions__DialogPauseHeading"].format(taskEntity.Number);
//            let subtitle = this.translations["OccurrenceTaskExecutions__DialogPause"].format(taskEntity.Number);

//            this.showStatusChangeDialog(taskEntity,
//                header,
//                subtitle,
//                lang.hitch(this,
//                    this._changeExecuterStatus,
//                    taskEntity,
//                    "ID_scheduled_task_executer_status_pause"
//                )
//            );
     
//        }

//        _onClick__CompleteTask: function (taskEntity) {

//            //dialog.set("SubTitle", "Die Ausführung zu Auftrag " + taskEntity.Number + " wird erledigt und eine Nachricht an den Meldenden geschickt.<br>Möchten Sie eine Anmerkung hinzufügen?");
//            //dialog.set("SubTitle", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish"].format(taskEntity.Number));

//            let header = this.translations["OccurrenceTaskExecutions__DialogConfirmFinishHeading"].format(taskEntity.Number);
//            let subtitle = this.translations["OccurrenceTaskExecutions__DialogConfirmFinish"].format(taskEntity.Number);

//            this.showStatusChangeDialog(taskEntity,
//                header,
//                subtitle,
//                lang.hitch(this,
//                    this._changeExecuterStatus,
//                    taskEntity,
//                    "ID_scheduled_task_executer_status_done"
//                )
//            );

//            //this.showStatusChangeDialog(taskEntity, header, subtitle, lang.hitch(this, "_onCompleteTaskCallback", taskEntity));

//        }

//        _onClick__StartTask: function (taskEntity) {
//            this._changeExecuterStatus(taskEntity, "ID_scheduled_task_executer_status_active");
//        }

//        _changeExecuterStatus: function (taskEntity, targetState, result) {

//            var note = this.taskInput.value;
//            var data = {
//                Note: note,
//                Assistants: this._assistantData,
//                Flatrates: this._flatratesData,
//                Workamount: parseFloat(this.inputWorkingAmount.value),
//                targetState: targetState
//            };


//            console.debug("_changeExecuterStatus", result, taskEntity, data);

//            // antwort vom Dialog? (bei Pausieren)
//            if (typeof (result) != "undefined") {
                
//                if (result < 1) { // Abbruch
//                    return;
//                }

//            }

//            this.StandbyStart();

//            var url = window.appRoot + "Occurrence/ChangeExecuterStatus";

//            this.RequestManager.post(
//                url,
//                {
//                    taskID: taskEntity.ID,
//                    jsonData: JSON.stringify(data)
//                }
//                lang.hitch(this, "_onChangeExecuterStatusResponse"),
//                lang.hitch(this, "_onChangeExecuterStatusError"),
//                false // sync
//            );

//        }

//        _onClick__AcceptTask: function (taskEntity) {
//            this.StandbyStart();

//            var url = window.appRoot + "Occurrence/AcceptTaskJSON";

//            this.RequestManager.post(
//                url,
//                {
//                    taskID: taskEntity.ID
//                }
//                lang.hitch(this, "_onChangeExecuterStatusResponse"),
//                lang.hitch(this, "_onChangeExecuterStatusError"),
//                false // sync
//            );
//        }

//        _onChangeExecuterStatusResponse: function () {
//            //this.loadScheduledTaskExecutors();
//            this.emit("ExecutersChanged");
//            this.StandbyStop();

//            if (this._flatratesSelect) {
//                this._flatratesSelect.destroy();
//                this._flatratesSelect = null;
//                this._flatratesData = null;
//                domConstruct.place(this.inputDiv, this.domNode);
//                domClass.add(this.inputDiv, "w3-hide");
//                domConstruct.empty(this.errorMessage);
//            }

//            //domConstruct.place(this.assistantContainer, this.domNode);
//            //domClass.add(this.assistantContainer, "w3-hide");

//            if (this._statusChangeDlg) {
//                setTimeout(domConstruct.destroy(this._statusChangeDlg.domNode), 1000);

//                this._statusChangeDlg = null;
//            }
//        }
//        _onChangeExecuterStatusError: function (error) {
//            this.StandbyStop();
//            alert(error.Message);

//            if (this._statusChangeDlg) {
//                this._statusChangeDlg.show();
//            }
//        }


//        _onCompleteTaskCallback: function (taskEntity, result) {

//            if (result != 1) {
//                return;
//            }

//            var input = this.taskInput;

//            this.StandbyStart();

//            var note = input.value;
//            var data = {
//                Note: note,
//                Assistants: this._assistantData,
//                Flatrates: this._flatratesData,
//                Workamount: parseFloat(this.inputWorkingAmount.value)
//            };


//            var url = window.appRoot + "Occurrence/CompleteTask";

//            this.RequestManager.post(
//                url,
//                {
//                    taskID: taskEntity.ID,
//                    jsonData: JSON.stringify(data)
//                }
//                lang.hitch(this, "_onCompleteTaskResponse"),
//                lang.hitch(this, "_onCompleteTaskError"),
//                false // sync
//            );

//            this._flatratesSelect.destroy();
//            this._flatratesSelect = null;
//            domConstruct.place(this.inputDiv, this.domNode);
//            domClass.add(this.inputDiv, "w3-hide");
//            domConstruct.empty(this.errorMessage);
//        }
//        _onCompleteTaskResponse: function () {
//            //this.loadScheduledTaskExecutors();
//            this.emit("ExecutersChanged");
//            this.StandbyStop();
//        }
//        _onCompleteTaskError: function (error) {
//            alert(error.Message);
//            this.StandbyStop();
//        }

//        _onLoadScheduledTaskExecutorsError: function (error) {
//            this.StandbyStop();
//        }

//        _onChangeSelectedFlatrates: function (values) {
//            console.debug("_onChange_SelectedFlatrates", values);

//            this.updateFlatrateRegistry();

//            this.buildFlatrateTable();
//        }

//        _loadFlatrates: function (taskEntity) {
//            this._flatratesSelect.StandbyStart();
//            var url = window.appRoot + "Occurrence/GetFlatrateList";

//            var data = { taskID: taskEntity.ID };
//            this._flatratesData = [];

//            this.RequestManager.post(
//                url,
//                {
//                    jsonData: JSON.stringify(data)
//                }
//                lang.hitch(this, this._loadFlatratesResponse),
//                lang.hitch(this, this._loadFlatratesError),
//                false // sync
//            );
//        }

//        _loadFlatratesResponse: function (response) {

//            this.buildFlatrateRegistry(response.flatrates);//, response.selectedValues);
//            //this.buildFlatrateTable(response.flatrates, response.selectedValues);
//            domConstruct.empty(this.errorMessage);

//            this._flatratesSelect.StandbyStop();
//            this._flatratesSelect.buildListValues(response.flatrates);// immer frisch starten!, response.rawSelectedValues);
//        }

//        _loadFlatratesError: function (error) {
//            this._flatratesSelect.StandbyStop();

//            this.errorMessage.innerHTML = error.Message;
//        }

//        buildFlatrateRegistry: function (originalList, selectedValues) {
//            // Pseudo-HT-Einträge machen
//            if (typeof (originalList != "undefined")) {
//                this._flatratesData = [];
//                for (var i = 0; i < originalList.length; i++) {

//                    var entry = originalList[i];

//                    var pseudoEntry = {
//                        isSelected: false, // kommt aus dem Multiselect!
//                        flatrateID: entry.ID,
//                        label: entry.bezeichnung,
//                        quantity: null, // noch nichts gewählt
//                        selectionID: null // keine ID, weils noch kein ht-entry gibt
//                    };

//                    this._flatratesData.push(pseudoEntry);
//                }
//            }

//            // jetzt aus den bereits gewählten Werten die Registry updaten
//            if (typeof (selectedValues ) != "undefined") {
//                for (var i = 0; i < selectedValues.length; i++) {
//                    //
//                    var selected = selectedValues[i];

//                    for (var x = 0; x < this._flatratesData.length; x++) {
//                        var pseudoEntry = this._flatratesData[x];

//                        if (pseudoEntry.flatrateID == selected.flatrateID) {
//                            //pseudoEntry.isSelected = true; // später -> wenn Multiselect befüllt ist setzen wir das Flag und zeichnen die Tabelle
//                            pseudoEntry.quantity = selected.quantity;
//                            pseudoEntry.selectionID = selected.ID;
//                            break;
//                        }
//                    }
//                }
//            }


//        }

//        updateFlatrateRegistry: function (targetID) {
//            var targetAmount = "1";
//            if (typeof (targetID) != "undefined") {
//                var input = document.getElementById(targetID);
//                targetAmount = input.value;
//            } else {

//            }

//            var selectedIDs = this._flatratesSelect.get("value");

//            for (var i = 0; i < this._flatratesData.length; i++) {
//                var pseudoEntry = this._flatratesData[i];
//                if (selectedIDs.indexOf(pseudoEntry.flatrateID) != -1) {
//                    pseudoEntry.isSelected = true;

//                    if (targetID == pseudoEntry.flatrateID || pseudoEntry.quantity == null) {
//                        pseudoEntry.quantity = parseFloat(targetAmount);
//                    }
//                } else {
//                    pseudoEntry.isSelected = false;
//                }
//            }

//            //console.debug("updated flatrate registry", this._flatratesData, selectedIDs, targetID, targetAmount);
//        }

//        buildFlatrateTable: function () {
//            domConstruct.empty(this.taskFlatratesTableContainer);
//            domClass.add(this.taskFlatratesTableContainer, "w3-hide");
//            var table = domConstruct.create("table", { "className": "flatrateTable" } this.taskFlatratesTableContainer);

//            //var headrow = domConstruct.create("tr", {}, table);

//            //var headLabel = domConstruct.create("th", { "innerHTML": "" }, headrow);
//            //var headLabel = domConstruct.create("th", { "innerHTML": "#" }, headrow);

//            for (var i = 0; i < this._flatratesData.length; i++) {
//                var pseudoEntry = this._flatratesData[i];

//                if (pseudoEntry.isSelected === true) {
//                    var row = domConstruct.create("tr", {}, table);

//                    var colLabel = domConstruct.create("td", { "innerHTML": pseudoEntry.label }, row);
//                    var colAmount = domConstruct.create("td", {}, row);
//                    var inputAmount = domConstruct.create("input", { "value": pseudoEntry.quantity, "type": "number", "step": "1", "className": "mds-bg-gray w3-input w3-margin-left w3-padding-small w3-border-gray" }, colAmount);
//                    inputAmount.id = pseudoEntry.flatrateID;

//                    on(inputAmount, "change", lang.hitch(this, this.updateFlatrateRegistry, pseudoEntry.flatrateID))
//                    domClass.remove(this.taskFlatratesTableContainer, "w3-hide");
//                }

//            }
//        }

//        _onSelect_InputAssistant: function (inputData) {
//            console.debug("_onSelect_InputAssistant", inputData);
//            //this.inputAssistantEmployee.set("value", null, true);
//            //for (let i = 0; i < this._assistantData.length; i++) {
//            //    if (this._assistantData[i].ID == inputData.ID) {
//            //        return;
//            //    }
//            //}
//            this._assistantData = inputData;
//            return;

//            let data = { node: null, ID: inputData.ID };

            

//            let node = domConstruct.create("div", { className: "flex_row_center w3-margin-top w3-margin-right" }, this.selectedAssistantContainer);
//            let label = domConstruct.create("span", { "innerHTML": inputData.dispname, className: "w3-padding-small mds-bg-gray" }, node);
//            let removebutton = domConstruct.create("div", { "innerHTML": "<i class='fa fa-times'></i>", className: "w3-padding-small mds-hover-dark w3-pale-red" }, node);

//            data.node = node;
//            this._assistantData.push(data);

//            on(removebutton, "click", lang.hitch(this, this._onClick_RemoveAssistant, inputData.ID));

//        }

//        _onClick_RemoveAssistant: function (ID, evt) {
//            evt.stopPropagation();

//            for (let i = 0; i < this._assistantData.length; i++) {
//                if (this._assistantData[i].ID == inputData.ID) {
//                    let data = this._assistantData[i];
//                    domConstruct.destroy(data.node);

//                    this._assistantData.splice(i, 1);
//                    return;
//                }
//            }
            
//        }


//        tableFormatterEmployee: function (cell, formatterParams, onRendered) {

//            var data = cell.getData();
//            var value = cell.getValue();

//            console.debug("tableFormatterEmployee", data);

//            let rawBGColor = "#fff";

//            if (data.ref_employee) {
//                if (data.ref_employee.ID == window.sessionInfo.sessionData.CurrentEmployeeId) {
//                    rawBGColor = "#8aa";
//                    domStyle.set(cell.getRow().getElement(), "outline", "2px solid " + rawBGColor);
//                    domStyle.set(cell.getRow().getElement(), "outlineOffset", "-2px");
//                    domStyle.set(cell.getRow().getElement(), "fontWeight", "bold");
//                }
//            }


//            return value;
//        }

//        tableFormatterStatus: function (cell, formatterParams, onRendered) {

//            var data = cell.getData();
//            var value = cell.getValue();

//            console.debug("tableFormatterStatus", data);

//            let rawColor = null;
//            if (data.ref_status) {
//                rawColor = data.ref_status.DisplayColor;
//            } else if (data.ref_scheduled_task_executer_status) { // bei der Unterliste mit Ausführungen!
//                rawColor = data.ref_scheduled_task_executer_status.DisplayColor;
//            }

//            if (rawColor == null || typeof (rawColor) == "undefined") {
//                return value;
//            }

//            //console.log("occurrenceTaskList tableFormatterStatus color", rawColor, data.ref_status);

//            var rawTextColor = "000000";

//           if (typeof (rawColor) == "object" && rawColor != null) {
               
//               var hexColor = rawColor.BackColor.Hex;
//               domStyle.set(cell.getElement(), "background-color", hexColor);

//               hexColor = rawColor.TextColor.Hex;
//               domStyle.set(cell.getElement(), "color", hexColor);

//           } else {
//               var hexColor = "#ccc";
//               domStyle.set(cell.getElement(), "background-color", hexColor);

//               hexColor = "330000";
//               domStyle.set(cell.getElement(), "color", hexColor);
//            }


//            return value;
//        }
//   }
}

Object.assign(OccurrenceFMTaskList.prototype, {
  templateString: template,
  occurrenceID: null,
  _executions: [],
  _files: [],
  _showExecutions: [],
  _statusChangeDlg: null,
  isExternalEmployee: false,
  _flatratesData: [],
  _assistantData: [],
  declaredClass: 'OccurrenceFMTaskList',
});
export default mdsWidget(OccurrenceFMTaskList, 'WidgetCollection/OccurrenceFM/OccurrenceTaskList');